import { METHOD } from '../method'

export const API_MAIN_BANNER = {
    DETAIL: {
        api: '/v1/dashboard-admin/main-page/home-page/main-banner',
        method: METHOD.GET,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/main-page/home-page/main-banner',
        method: METHOD.PUT,
    },
    URL_MAIN_BANNER: {
        api: '/v1/dashboard-admin/main-page/home-page/main-banner/storage-url/attachment',
        method: METHOD.POST,
    },
}
